"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getNotificationOffset = getNotificationOffset;
exports.NotificationSystemProvider = NotificationSystemProvider;
exports.useNotificationSystem = useNotificationSystem;

var _map = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/map"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/toConsumableArray"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectSpread"));

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _Box = _interopRequireDefault(require("../Box"));

var _index = require("../index");

var _useWindowSize = _interopRequireDefault(require("../useWindowSize"));

var _uniqueId = _interopRequireDefault(require("../uniqueId"));

var __jsx = _react["default"].createElement;

var NotificationsContext = _react["default"].createContext({}); // TODO: make alerts visually-hidden instead of removing from DOM
// TODO: make it possible to show notification into ref
// notificationSystemOffset
// notificationSystemOffsetX notificationSystemOffsetY, notificationSystemMenuOffsetY notificationSystemMenuOffsetX


function getNotificationOffset(theme) {
  var s = theme.space;
  var top = {
    x: s.notificationSystemOffsetX || s.notificationSystemOffset || 0,
    y: s.notificationSystemOffsetY || s.notificationSystemOffset || 0
  };
  var bottom = {
    x: s.notificationSystemOffsetX || s.notificationSystemOffset || 0,
    y: s.notificationSystemOffsetY || s.notificationSystemOffset || 0
  };
  var topMenu = {
    x: s.notificationSystemOffsetMenuX || s.notificationSystemOffsetMenu || s.notificationSystemOffsetX || s.notificationSystemOffset || 0,
    y: s.notificationSystemOffsetMenuY || s.notificationSystemOffsetMenu || s.notificationSystemOffsetY || s.notificationSystemOffset || 0
  };
  return {
    top: top,
    bottom: bottom,
    topMenu: topMenu
  }; // if (placement === "topLeft") {
  //   topLeft.push(content);
  //   topMobile.push(content);
  // } else if (placement === "topRight") {
  //   topRight.push(content);
  //   topMobile.push(content);
  // } else if (placement === "bottomLeft") {
  //   bottomLeft.push(content);
  //   bottomMobile.push(content);
  // } else if (placement === "bottomRight") {
  //
  //
  // }
}

function NotificationSystemProvider(_ref) {
  var children = _ref.children;

  var _useState = (0, _react.useState)(false),
      mounted = _useState[0],
      setMounted = _useState[1];

  var _useResponsiveHelpers = (0, _index.useResponsiveHelpers)(),
      currentValue = _useResponsiveHelpers.currentValue;

  var _useState2 = (0, _react.useState)([]),
      notifications = _useState2[0],
      setNotifications = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      isLayerOpen = _useState3[0],
      setLayerOpen = _useState3[1];

  var _close = function close(notification) {
    setNotifications(function (notifications) {
      return notifications.filter(function (x) {
        return x.id !== notification.id;
      });
    });
  };

  (0, _react.useEffect)(function () {
    window.window.__cui_notificationSystemSetLayerOpen = function (isOpen) {
      // We do it this way so that Layer doesn't have to import MenuLayout if not needed (code split!)
      setLayerOpen(isOpen);
    };
  }, []);

  var show = function show(config) {
    var id = config.id || (0, _uniqueId["default"])();
    var index = notifications.findIndex(function (x) {
      return x.id === id;
    });

    if (index > -1) {
      clearTimeout(notifications[index].timeout);
    }

    var newNotification = (0, _objectSpread2["default"])({}, config, {
      id: id
    });

    if (typeof config.timeout === "number" && config.timeout > 0) {
      newNotification.timeout = setTimeout(function () {
        _close(newNotification);
      }, config.timeout);
    }

    var newNotifications = (0, _toConsumableArray2["default"])(notifications);

    if (index > -1) {
      newNotifications[index] = newNotification;
    } else {
      newNotifications.push(newNotification);
    }

    setNotifications(newNotifications);
  };

  (0, _react.useEffect)(function () {
    setMounted(true);
  }, []);

  var _ = (0, _useWindowSize["default"])(); // unused but rerenders on resize


  var portals;

  if (mounted) {
    var topLeft = [];
    var topRight = [];
    var topMobile = [];
    var topLeftMenu = [];
    var topRightMenu = [];
    var topMobileMenu = [];
    var bottomLeft = [];
    var bottomRight = [];
    var bottomMobile = [];
    var refs = new _map["default"]();
    notifications.forEach(function (notification) {
      var placement = currentValue(notification.placement); // TODO: this function can't use hook!!!

      var content = typeof notification.content === "function" ? notification.content({
        close: function close() {
          _close(notification);
        }
      }) : notification.content; // TODO: accessibility!!

      content = __jsx(_Box["default"], {
        sx: {
          display: "contents"
        },
        role: "alert",
        key: notification.id
      }, content);

      if (typeof placement === "string") {
        // Menu placement is replaced by standard placement when dialogs are open
        if (placement === "topLeftMenu" && isLayerOpen) {
          placement = "topLeft";
        } else if (placement === "topRightMenu" && isLayerOpen) {
          placement = "topRight";
        }

        if (placement === "topLeft") {
          topLeft.push(content);
          topMobile.push(content);
        } else if (placement === "topRight") {
          topRight.push(content);
          topMobile.push(content);
        } else if (placement === "bottomLeft") {
          bottomLeft.push(content);
          bottomMobile.push(content);
        } else if (placement === "bottomRight") {
          bottomRight.push(content);
          bottomMobile.push(content);
        } else if (placement === "topLeftMenu") {
          topLeftMenu.push(content);
          topMobileMenu.push(content);
        } else if (placement === "topRightMenu") {
          topRightMenu.push(content);
          topMobileMenu.push(content);
        } else {
          throw new Error("unknown position " + placement + " for notification");
        }
      } else {
        if (!placement.current) {
          throw new Error("placement for notification can be either string with position (topLeft, topRight, etc...) or ref");
        }

        if (refs.has(placement.current)) {
          refs.set(placement.current, [].concat((0, _toConsumableArray2["default"])(refs.get(placement.current)), [content]));
        } else {
          refs.set(placement.current, [content]);
        }
      }
    });
    portals = [// ReactDOM.createPortal(
    //   topLeft,
    //   document.getElementById(
    //     isLayerOpen
    //       ? "__notifications-topLeft__"
    //       : "__notifications-menu-topLeft__"
    //   ) || document.getElementById("__notifications-topLeft__") // if there's no menu we must default
    // ),
    // ReactDOM.createPortal(
    //   topRight,
    //   document.getElementById(
    //     isLayerOpen
    //       ? "__notifications-topRight__"
    //       : "__notifications-menu-topRight__"
    //   ) || document.getElementById("__notifications-topRight__")
    // ),
    // ReactDOM.createPortal(
    //   topMobile,
    //   document.getElementById(
    //     isLayerOpen
    //       ? "__notifications-topMobile__"
    //       : "__notifications-menu-topMobile__"
    //   ) || document.getElementById("__notifications-topMobile__")
    // ),
    _reactDom["default"].createPortal(topLeftMenu, document.getElementById("__notifications-menu-topLeft__") || document.getElementById("__notifications-topLeft__")), _reactDom["default"].createPortal(topRightMenu, document.getElementById("__notifications-menu-topRight__") || document.getElementById("__notifications-topRight__")), _reactDom["default"].createPortal(topMobileMenu, document.getElementById("__notifications-menu-topMobile__") || document.getElementById("__notifications-topMobile__")), _reactDom["default"].createPortal(topLeft, document.getElementById("__notifications-topLeft__")), _reactDom["default"].createPortal(topRight, document.getElementById("__notifications-topRight__")), _reactDom["default"].createPortal(topMobile, document.getElementById("__notifications-topMobile__")), _reactDom["default"].createPortal(bottomLeft, document.getElementById("__notifications-bottomLeft__")), _reactDom["default"].createPortal(bottomRight, document.getElementById("__notifications-bottomRight__")), _reactDom["default"].createPortal(bottomMobile, document.getElementById("__notifications-bottomMobile__"))];
    refs.forEach(function (value, keyRef) {
      portals.push(_reactDom["default"].createPortal(value, keyRef));
    });
  }

  return __jsx(NotificationsContext.Provider, {
    value: {
      show: show
    }
  }, children, portals);
} // export function Notifications


function useNotificationSystem() {
  return (0, _react.useContext)(NotificationsContext);
}